export default __webpack_public_path__ + "static/comics-ea773a584b4dac1b22ceec25286365dd.png";